module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Carlisle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Carlisle’s love affair with books began when she made a bad grade in math. Not allowed to watch TV until the grade had improved, she filled her time with books.Turning her love of reading into a love for writing romance, she pens hot medicals.She loves castles, traveling, afternoon tea, reads voraciously and hearing from her readers. Join her newsletter at "), _c('a', {
    attrs: {
      "href": "http://www.susancarlisle.com/"
    }
  }, [_vm._v("www.SusanCarlisle.com")]), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BFHsR6/tc-custom/9781460310908.jpg?1725275608037",
      "alt": "This image is the cover for the book NYC Angels: The Wallflower's Secret"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("NYC Angels: The Wallflower's Secret\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("Some secrets are best shared")])]), _c('br'), _c('br'), _vm._v("Since making the ultimate emotional sacrifice for her sister, counsellor Lucy Edwards has kept her feelings buried and her heart on lockdown. Enter neurosurgeon Ryan O'Doherty, complete with piercing blue eyes and roguish charm. Working with him on an emotive case brings all of Lucy's painful memories to the surfaceand even closer to Ryan. Lucy's finally tempted to let someone inbut will their fragile relationship survive her most difficult revelation?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0